import * as React from "react";
import { useDialog } from "@shared-ui/dialog-context";
import { ItemKeyHelper } from "components/utility/ItemKeyHelper";
import LinksGridItem from "components/flexComponents/Links/GridView/LinksGridItem";
import { LinkDialog } from "components/flexComponents/Links/GridView/LinkDialog";
import { UitkLayoutGrid } from "uitk-react-layout-grid";
import { UitkCard, UitkCardContentSection } from "uitk-react-cards";
import { ExtendedContextStore } from "typings/flexFramework/FlexDefinitions";
import { Viewport, ViewSmall, ViewMedium, ViewLarge } from "bernie-view";
import { UitkSpacing } from "uitk-react-spacing";
import { BlossomComponent } from "src/components/flexFramework/domain/BlossomComponent";

interface LinksGridWithDialogProps {
  groups: BlossomComponent[];
  view: string;
  id: string;
  context: ExtendedContextStore;
}

const LinksGridWithDialog = (props: LinksGridWithDialogProps) => {
  const { groups, view, id, context } = props;

  return (
    <Viewport>
      <ViewSmall>
        <LinksGridWithDialogDom groups={groups} view={view} id={id} context={context} columns={1} />
      </ViewSmall>
      <ViewMedium>
        <LinksGridWithDialogDom
          groups={groups}
          view={view}
          id={id}
          context={context}
          columns={groups.length === 1 ? 1 : 2}
        />
      </ViewMedium>
      <ViewLarge>
        <LinksGridWithDialogDom
          groups={groups}
          view={view}
          id={id}
          context={context}
          columns={groups.length === 1 ? 1 : 3}
        />
      </ViewLarge>
    </Viewport>
  );
};

interface LinksGridWithDialogDomProps {
  groups: BlossomComponent[];
  view: string;
  id: string;
  context: ExtendedContextStore;
  columns: any;
}

const LinksGridWithDialogDom = ({ groups, view, id, context, columns }: LinksGridWithDialogDomProps) => {
  const linkGridRef = React.useRef<any>();
  const [, dialogActions, LinkDialogComponent] = useDialog(`linksDialog-${id}`);
  const keyHelper = new ItemKeyHelper("LinksGroup");
  const linksCardView = view === "standard-link" && groups.length === 1 ? "unset" : "two";

  const onDismiss = () => {
    dialogActions.closeDialog();
    linkGridRef.current?.focus();
  };

  return (
    <div className="LinksGridWithDialog">
      <UitkCard>
        <UitkSpacing padding={{ inline: linksCardView }}>
          <UitkCardContentSection padded={false}>
            <UitkLayoutGrid space="one" columns={columns}>
              {groups.map((group) => (
                <LinksGridItem
                  key={keyHelper.next()}
                  view={view}
                  group={group}
                  id={id}
                  context={context}
                  linkGridRef={linkGridRef}
                />
              ))}
              <LinkDialogComponent>
                <LinkDialog key={keyHelper.next()} id={id} onDismiss={onDismiss} />
              </LinkDialogComponent>
            </UitkLayoutGrid>
          </UitkCardContentSection>
        </UitkSpacing>
      </UitkCard>
    </div>
  );
};

export default LinksGridWithDialog;
